import homeContent from "./content/home.json";

export const homeMock = {
  name: "home",
  layoutType: 1,
  areasList: [
    {
      id: "home-1",
      name: "home-content",
      componentName: "Comp:HomePage",
      content: JSON.stringify(homeContent),
    },
  ],
};
